const getMeta = require('../../../functions/getMeta')

/**
 * @type Controller
 * @name PrintEpgCtrl
 * @packageName print_epg_ctrl.js
 *
 * @description
 *
 * The `PrintRundownCtrl` interaction delete mdDialog for rundown
 *
 */
class PrintEpgCtrl {


    constructor($scope, $mdDialog, locals, $http) {


    	//Attach dependicies to class root
    	this.$mdDialog = $mdDialog;
        this.selectedTemplate = locals.templateId;
        $scope.selectedDate = {value: new Date()};
        this.$scope = $scope;
        this.$http = $http;

    	//Ugly work around CANCEL button!
    	$scope.cancel = () => {
    		this.cancelButton();
    	};

		//Ugly work around OK button!
    	$scope.ok = () => {
    		this.ok();
    	};

    	$scope.print = () => {
    	    this.print();
        };


        $scope.selectedDate = new Date();

    }


	/*
     * managed CANCEL event from confirm dailog
     */
    cancelButton () {
        this.$mdDialog.cancel();
    }


	print() {
        let value = moment(this.$scope.selectedDate, 'YYYY-MM-DD hh:mm:ss a').format('YYYY-MM-DD');
        //Open the printpage in a new tab using an anchor with rel='noopener'
        //Else the new tab will use the same renderer as the original page and window.print() will freeze the rundown
        //This seems to be the only workaround for this, source:
        //https://bugs.chromium.org/p/chromium/issues/detail?id=178931

        let anchor = window.document.createElement('a');
        anchor.href = `print/broadcastsofweektemplate/${value}/${this.selectedTemplate}?_token=${getMeta('csrf-token')}`;
        anchor.target = '_blank';
        anchor.rel = 'noopener';
        anchor.click();
    }
}


/*
 * Inject dependicies
 */
PrintEpgCtrl.$inject = ['$scope', '$mdDialog', 'locals', '$http'];


/*
 * Browsify connection: execute controller
 */
module.exports = PrintEpgCtrl;
